import dayjs from 'dayjs';

/**
 * Calculate age in years
 *
 * @param {Date} birthday
 * @returns {Number} years as a float, using 0 for dates in the future
 */
export default function calculateAgeFromBirthday(birthday) {
    if (!birthday) {
        return null;
    }

    const today = dayjs().startOf('day');
    const parsedBirthday = dayjs(birthday).startOf('day');

    const yearsInThePast = today.diff(parsedBirthday, 'years', true);
    return yearsInThePast > 0
        ? yearsInThePast
        : 0;
}
